import React, { useEffect, useState } from 'react';
import { motion } from 'motion/react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, ArrowRight } from 'lucide-react';

const OnAuthSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/login');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 via-blue-50 to-indigo-50 p-4" data-id="3nq9wgtid" data-path="src/pages/OnAuthSuccess.tsx">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md" data-id="w8dldan3w" data-path="src/pages/OnAuthSuccess.tsx">

        <Card className="shadow-2xl border-0 bg-white/95 backdrop-blur-sm text-center" data-id="kpbcxljdw" data-path="src/pages/OnAuthSuccess.tsx">
          <CardHeader className="pb-6" data-id="1edwcmkmo" data-path="src/pages/OnAuthSuccess.tsx">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
              className="flex justify-center mb-4" data-id="1x7fvo1e4" data-path="src/pages/OnAuthSuccess.tsx">

              <div className="p-3 bg-gradient-to-r from-green-500 to-blue-600 rounded-full" data-id="qoae85pj0" data-path="src/pages/OnAuthSuccess.tsx">
                <CheckCircle className="h-8 w-8 text-white" data-id="e80llg6pu" data-path="src/pages/OnAuthSuccess.tsx" />
              </div>
            </motion.div>
            <CardTitle className="text-2xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent" data-id="bvd704zoi" data-path="src/pages/OnAuthSuccess.tsx">
              Registration Successful!
            </CardTitle>
          </CardHeader>
          
          <CardContent className="space-y-4" data-id="7vtj9xa7g" data-path="src/pages/OnAuthSuccess.tsx">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="text-gray-600" data-id="ev4elw4fo" data-path="src/pages/OnAuthSuccess.tsx">

              <p className="mb-4" data-id="ra1qeeyky" data-path="src/pages/OnAuthSuccess.tsx">
                Your account has been successfully verified and created.
              </p>
              <p className="text-sm text-gray-500" data-id="ey0izdtti" data-path="src/pages/OnAuthSuccess.tsx">
                You will be redirected to the login page in {countdown} seconds.
              </p>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
              className="flex items-center justify-center text-blue-600 text-sm" data-id="i1hz0xgx9" data-path="src/pages/OnAuthSuccess.tsx">

              <ArrowRight className="h-4 w-4 mr-1" data-id="xyloxn0eu" data-path="src/pages/OnAuthSuccess.tsx" />
              Redirecting to login...
            </motion.div>
          </CardContent>
        </Card>
      </motion.div>
    </div>);

};

export default OnAuthSuccess;